import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Layout from "../components/Layout/Layout";
import IMAGES from "../img/image";
import website from "../website/data";
import "./css/Contact.css";
import { apiClient } from "../config/api.client";
import { userExist } from "../redux/features/userSlice";

const Contact = () => {
	const { user } = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [form, setForm] = useState({
		name: user?.fname,
		email: user?.email,
		mobile: user?.mobile,
		type: "",
		msg: [],
	});
	const [error, setError] = useState(false);
	const [mapLoader, setMapLoader] = useState(true);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (name === "msg") {
			setForm((prevForm) => ({
				...prevForm,
				msg: [
					{
						msg: value,
						person: "user",
					},
				],
			}));
		} else {
			setForm({ ...form, [name]: value });
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (
			form?.name === "" ||
			form?.email === "" ||
			form?.mobile === "" ||
			form?.msg?.length === 0
		) {
			setError(true);
			return;
		}
		try {
			const res = await apiClient.post("/contact/add-contact-form", form);
			if (res.data.success) {
				message.success(res.data.message);
				setForm({ name: "", email: "", mobile: "", msg: "" });
				setError(false);
			} else {
				message.error(res.data.message);
				setError(false);
			}
		} catch (error) {
			setError(false);
			console.log(error);
		}
	};

	const getUserData = async () => {
		apiClient
			.post(
				"/user/me",
				{},
				{
					headers: {
						Authorization: "Bearer " + localStorage.getItem("token"),
					},
				}
			)
			.then((res) => {
				setForm(res.data.data.user);
				dispatch(userExist(res.data.data));
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		getUserData();
		if (!user || user === null) {
			navigate("/login");
			message.error("Please login first");
		}
	}, []);

	return (
		<Layout>
			<div className="contact-page-container">
				<div className="row">
					{user && (
						<div
							className="d-block d-md-block d-lg-none"
							onClick={() => navigate("/query")}
						>
							<div className="gotochat">
								<span>Go to Chats</span>
								<ArrowForwardIosIcon className="icon" />
							</div>
						</div>
					)}
					<div className="d-none d-lg-block col-12 col-sm-12 col-md-6 col-lg-6 contact-image">
						<img src={IMAGES.support} alt="" />
					</div>
					<div className="col-12 col-sm-12 col-md-6 col-lg-6 contact-form">
						<p>Our Support</p>
						<h2>{website.name} Support</h2>
						<span>
							Our knowledgeable team is eager to assist you with any inquiries
							you have!
						</span>
						<form onSubmit={handleSubmit}>
							{/* <div className="form-fields">
                <input
                  onChange={handleChange}
                  name="name"
                  className="form-control"
                  type="text"
                  value={form.name}
                  placeholder="Enter your name"
                />
                <span className="text-danger">
                  <small>
                    {error && form?.name === "" && "Please enter your name"}
                  </small>
                </span>
              </div> */}
							{/* <div className="form-fields">
                <input
                  onChange={handleChange}
                  name="email"
                  className="form-control"
                  type="email"
                  value={form.email}
                  placeholder="Enter your email"
                />
                <span className="text-danger">
                  <small>
                    {error && form?.email === "" && "Please enter your email"}
                  </small>
                </span>
              </div> */}
							{/* <div className="form-fields">
                <input
                  onChange={handleChange}
                  name="mobile"
                  className="form-control"
                  type="text"
                  value={form.mobile}
                  placeholder="Enter your phone number"
                />
                <span className="text-danger">
                  <small>
                    {error && form?.mobile === "" && "Please enter your mobile"}
                  </small>
                </span>
              </div> */}
							<div className="form-fields">
								<select
									className="form-select"
									name="type"
									onChange={handleChange}
									value={form?.type}
								>
									<option value="">Select Query Type</option>
									<option value="Payment Related Query">
										Payment Related Queries
									</option>
									<option value="In-Game Recharge Query">
										In-Game Recharge Query
									</option>
									<option value="Wanted to be a Reseller">
										Wanted to be a Reseller
									</option>
									<option value="others">Other Query</option>
								</select>
								<span className="text-danger">
									<small>
										{error && form?.type === "" && "Select Query Type"}
									</small>
								</span>
							</div>
							<div className="form-fields">
								<textarea
									onChange={handleChange}
									className="form-control"
									value={
										form?.msg?.length > 0
											? form.msg[form?.msg?.length - 1].message
											: ""
									}
									name="msg"
									rows="3"
									placeholder="How can we help you?"
								></textarea>
								<span className="text-danger">
									<small>
										{error &&
											form?.msg?.length === 0 &&
											"Please enter your message"}
									</small>
								</span>
							</div>
							<button type="submit" className="theme-btn w-100">
								Submit
							</button>
						</form>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default Contact;
